export abstract class VimCoreBaseConfig {
  rootDomain: string;
  boilerplateEndpoint: string;
  blocksStoreEndpoint: string;
  serverLogger: {
    enabled: boolean;
    logUrl: string;
  };
  video?: {
    verboseLogging?: boolean;
  };
}
